import classNames from 'classnames';
import { List } from 'immutable';
import { Fragment, ReactNode, useMemo } from 'react';
import { CSSTransition } from 'react-transition-group';

import { i18n } from 'utils/i18n';

import './tooltip-error.scss';

type AuthError = List<any> | boolean;

export const AuthFormTooltipError = ({
  children = i18n.t('This field is mandatory'),
  error,
}: {
  children: ReactNode;
  error?: AuthError;
}) => {
  const ErrorMessage = ({
    header = '',
    rules = [],
  }: {
    header: string;
    rules: { label: string; valid: boolean }[];
  }) => {
    const key = useMemo(
      () =>
        rules.reduce(
          (acc, rule) => `${acc},rule:${rule.label}`,
          `header:${header}`,
        ),
      [header, rules],
    );
    return (
      <Fragment key={key}>
        {header && <div className="AuthFormTooltipError__header">{header}</div>}
        <ul className="AuthFormTooltipError__rules alk-list">
          {rules.map((rule) => (
            <li
              key={rule.label}
              className={classNames('AuthFormTooltipError__rule', {
                'AuthFormTooltipError__rule--valid': rule.valid,
              })}
            >
              {rule.label}
            </li>
          ))}
        </ul>
      </Fragment>
    );
  };

  return (
    <CSSTransition timeout={400} classNames="fade" appear in>
      <div className="AuthFormTooltipError">
        {(List.isList(error) && !(error as List<any>).isEmpty()
          ? (error as List<any>).map((err, i) => (
              <ErrorMessage key={i} {...err.toJS()} />
            ))
          : children) || i18n.t('This field is mandatory')}
      </div>
    </CSSTransition>
  );
};

export default AuthFormTooltipError;
